import apiClient from './apiClient';

export async function fetchEmployeeReferral() {
  const { data } = await apiClient.get('/employee-referral');
  return data;
}

/** Distinct companies from admin Referral Panel (authenticated). */
export async function fetchReferralPanelCompanies() {
  const { data } = await apiClient.get('/employee-referral/referral-panel-companies');
  return Array.isArray(data) ? data : [];
}

/**
 * Address fields come from Profile (users table). Payload is referral-only fields.
 * @param {{
 *   interestedJobs: { company: string, jobUrls: string[] }[],
 * }} payload interestedJobs length ≤ 20
 */
export async function saveEmployeeReferral(payload) {
  const { data } = await apiClient.put('/employee-referral', payload);
  return data;
}

export async function uploadReferralResume(file) {
  const body = new FormData();
  body.append('file', file);
  const { data } = await apiClient.post('/employee-referral/resume', body);
  return data;
}

export async function copyReferralResumeFromProfile() {
  const { data } = await apiClient.post('/employee-referral/resume-from-profile');
  return data;
}

export async function deleteReferralResume() {
  const { data } = await apiClient.delete('/employee-referral/resume');
  return data;
}

export async function downloadReferralResume() {
  const res = await apiClient.get('/employee-referral/resume/download', { responseType: 'blob' });
  const disposition = res.headers?.['content-disposition'] || '';
  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  const asciiMatch = /filename="([^"]+)"/i.exec(disposition);
  let filename = 'resume';
  if (utf8Match) {
    try {
      filename = decodeURIComponent(utf8Match[1]);
    } catch {
      filename = utf8Match[1];
    }
  } else if (asciiMatch) filename = asciiMatch[1];

  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
